module.exports = __webpack_public_path__ + "static/media/2.ff594ce3.jpg";